export const EXCEL_CHECK_EXISTING_SESSION = `
  query ExcelCheckExistingSession($user: String!) {
    session_by_pk(
      folio_user: $user
      is_mobile: false
    ) {
      id
      excel_session_id
      last_seen
    }
  }
`;

export const EXCEL_UPDATE_SESSION = `
  mutation ExcelUpdateSession(
    $user: String!
    $excel_session_id: String!
  ) {
    insert_session_one(
      object: {
        folio_user: $user
        is_mobile: false
        id: $excel_session_id
        excel_session_id: $excel_session_id
        excel: true
        last_seen: "now()"
      }
      on_conflict: {
        constraint: session_pkey
        update_columns: [last_seen, excel_session_id, excel]
      }
    ) {
      id
      excel_session_id
      last_seen
    }
  }
`;

export const EXCEL_LIVENESS_PROBE = `
  mutation ExcelLiveness(
    $user: String!
    $excel_session_id: String!
  ) {
    insert_session_one(
      object: {
        folio_user: $user
        is_mobile: false
        id: $excel_session_id
        excel_session_id: $excel_session_id
        excel: true
        last_seen: "now()"
      }
      on_conflict: {
        constraint: session_pkey
        update_columns: [last_seen, excel_session_id, excel]
      }
    ) {
      id
      excel_session_id
      last_seen
    }
    update_folio_user_by_pk(
      pk_columns: { id: $user }
      _set: { last_seen: "now()" }
    ) {
      id
    }
  }
`;

export const EXCEL_SESSION_SUBSCRIPTION = `
  subscription ExcelSession($user: String!) {
    session_by_pk(
      folio_user: $user
      is_mobile: false
    ) {
      id
      excel_session_id
      last_seen
    }
  }
`;

export const EXCEL_CLEAR_SESSION = `
  mutation ExcelClearSession($user: String!, $excel_session_id: String!) {
    update_session(
      where: {
        folio_user: { _eq: $user }
        is_mobile: { _eq: false }
        excel_session_id: { _eq: $excel_session_id }
      }
      _set: { 
        excel_session_id: null
      }
    ) {
      affected_rows
      returning {
        id
        excel_session_id
      }
    }
  }
`;


